import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import { theme } from '../../../../../domain/theme';
import { t } from '../../../../../domain/services/configService';
import { IconSearch } from '../../../../Icon/IconSearch';
import { Actionable } from '../../../atoms/Actionable';
import { Modal } from '../../Modal';
import { ExpandedSearch } from '../../../../ExpandedSearch';

const styles = {
  searchIcon: css`
    padding: ${theme.spacing.parse('0 $xs')};
    display: grid;
    place-items: center;
  `
};

export const SearchMenuItem = () => {
  const [isSearchExpanded, setSearchExpanded] = useState(false);
  const openSearch = () => setSearchExpanded(true);
  const closeSearch = () => setSearchExpanded(false);

  useEffect(() => {
    window.addEventListener('openSearch', openSearch);
    return () => window.removeEventListener('openSearch', openSearch);
  }, []);

  return (
    <>
      <div css={styles.searchIcon} title={t('Search')}>
        <Actionable title={t('Search')} onClick={openSearch}>
          <IconSearch />
        </Actionable>
      </div>
      <Modal show={isSearchExpanded} overlayColor="#000" closeCb={closeSearch}>
        <ExpandedSearch closeCb={closeSearch} />
      </Modal>
    </>
  );
};
